import React from 'react'
import Avatar from "@material-ui/core/Avatar";
const Rowrecord = () => {
  return (
    <>
    
    <tr className="table-everyone-order-row">
        <td>224566856</td>
        <td className="avatar-no">
          <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />
          123468
        </td>
        <td className="avatar">
          {" "}
          <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />
        </td>
        <td>₹4000</td>
      </tr>
    
    
    
    </>
  )
}

export default Rowrecord